<app-request-an-insurance-quote mainHeading="QUOTE REQUEST" subHeading="false"></app-request-an-insurance-quote>
<!-- START OF FORM -->
<form (ngSubmit)="onSubmit(underWriting)" #underWriting="ngForm">
    <section id="rtq-form" class="pb-5">
        <div class="container">
            <img src="assets/img/PRELOADER.gif" class="preloader" *ngIf="isLoading" />
            <div class="row justify-content-center">
                <div class="col-md-8 col-xs-12">
                    <p *ngIf="this.dataService.leadDetails.isServiceUnavailable==false">
                        {{this.dataService.leadDetails.errorMessage}}
                    </p>
                    <span class="pl-3" *ngIf="this.dataService.leadDetails.isServiceUnavailable==false">Underwriting
                        Information</span>
                    <br>
                    <br>
                    <div class="form-div z-indexHeader">
                        <div class="row pt-3">
                            <div class="col">
                                <label for="lblLoanTransaction">Does or will the property have a pool or spa?<span>
                                        *</span></label>
                                <select class="form-control poolWidth" required [(ngModel)]="supplementalInfo.poolType"
                                    #poolType="ngModel" name="ddlPolTypes">
                                    <option selected value=""></option>
                                    <option *ngFor="let item of supplementalInfo.lstPoolTypes" [value]="item.lookupId">
                                        {{item.lookupValue}}
                                    </option>
                                </select>
                                <label *ngIf="(poolType.hasError('required') && poolType.touched) "
                                    class="error-message text-nowrap">{{constantsObj.requiredErrorMessage}}</label>
                            </div>
                        </div>
                        <div class="row pt-3"
                            *ngIf="supplementalInfo.poolType!=null && supplementalInfo.poolType!='' && supplementalInfo.poolType!=swimmingPoolNoneID">
                            <div class="col">
                                <label for="lblPoolYes">Select any that apply (more than 1 may apply)</label>
                                <div class="col">
                                    <div class="form-check form-check-inline pb-2 row w-100">
                                        <button type="button" [(ngModel)]="supplementalInfo.isPoolFence" [value]="true"
                                            (click)="supplementalInfo.isPoolFence?supplementalInfo.isPoolFence=false:supplementalInfo.isPoolFence=true;"
                                            #isPoolFence="ngModel" name="rdisPoolFence" ngDefaultControl
                                            [ngClass]="{'active': supplementalInfo.isPoolFence}"
                                            class="radio-btn btn btn-outline-dark">
                                            Fenced or Caged
                                        </button>
                                    </div>
                                    <div *ngIf="supplementalInfo.isPoolFence"
                                        class="form-check form-check-inline pb-2 row w-100">
                                        <button type="button" [(ngModel)]="supplementalInfo.locked" [value]="true"
                                            (click)="toggleLocked()" #.locked="ngModel" name="rd.locked"
                                            ngDefaultControl [ngClass]="{'active': supplementalInfo.locked}"
                                            class="radio-btn btn btn-outline-dark">
                                            Fence/Cage W/Locking Gate Or No Entry
                                        </button>
                                    </div>
                                    <div class="form-check form-check-inline pb-2 row w-100">
                                        <button type="button" [(ngModel)]="supplementalInfo.haveSlideDivingBoard"
                                            [value]="true"
                                            (click)="supplementalInfo.haveSlideDivingBoard?supplementalInfo.haveSlideDivingBoard=false:supplementalInfo.haveSlideDivingBoard=true;"
                                            #haveSlideDivingBoard="ngModel" name="rdhaveSlideDivingBoard"
                                            ngDefaultControl
                                            [ngClass]="{'active': supplementalInfo.haveSlideDivingBoard}"
                                            class="radio-btn btn btn-outline-dark">
                                            Diving Board/Slide
                                        </button>

                                    </div>

                                </div>
                            </div>
                        </div>
                        <div class="row pt-3">
                            <div class="col">
                                <label for="lblforAny">Select Any Of These That Apply (more than 1 may apply)</label>

                            </div>
                        </div>
                        <div class="row pt-3">
                            <div class="col">
                                <div class="col">
                                    <div class="form-check form-check-inline pb-2 row w-100">
                                        <button type="button" [(ngModel)]="supplementalInfo.haveTrampoline"
                                            [value]="true"
                                            (click)="supplementalInfo.haveTrampoline?supplementalInfo.haveTrampoline=false:supplementalInfo.haveTrampoline=true;"
                                            #haveTrampoline="ngModel" name="radTrampoline" ngDefaultControl
                                            [ngClass]="{'active': supplementalInfo.haveTrampoline}"
                                            class="radio-btn btn btn-outline-dark">
                                            Trampoline
                                        </button>

                                    </div>
                                </div>

                            </div>
                        </div>
                        <div class="row pt-3">
                            <div class="col">
                                <div class="col">
                                    <div class="form-check form-check-inline pb-2 row w-100">
                                        <button type="button" [(ngModel)]="supplementalInfo.isVacant" [value]="true"
                                            (click)="supplementalInfo.isVacant?supplementalInfo.isVacant=false:supplementalInfo.isVacant=true;"
                                            #isVacant="ngModel" name="radisVacant" ngDefaultControl
                                            [ngClass]="{'active': supplementalInfo.isVacant}"
                                            class="radio-btn btn btn-outline-dark">
                                            Property Vacant
                                        </button>

                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row pt-3">
                            <div class="col">
                                <div class="col">
                                    <div class="form-check form-check-inline pb-2 row w-100">
                                        <button type="button" [(ngModel)]="supplementalInfo.haveDogs" [value]="true"
                                            (click)="supplementalInfo.haveDogs?(UnCheck(template,'dogs')):supplementalInfo.haveDogs=true"
                                            #haveDogs="ngModel" name="radhaveDogs" ngDefaultControl
                                            [ngClass]="{'active': supplementalInfo.haveDogs}"
                                            class="radio-btn btn btn-outline-dark">
                                            Dogs
                                        </button>
                                    </div>
                                </div>

                            </div>
                        </div>

                        <!-- Start of Hide show table on click Do you own any dogs?  as YES -->
                        <div class="row pt-3" *ngIf="supplementalInfo.haveDogs">

                            <div class="col">
                                <table class="table table-bordered table-responsive">
                                    <thead class="table-header">
                                        <tr>
                                            <th scope="col">#</th>
                                            <th scope="col">Breed</th>
                                            <th scope="col">Mixed With</th>
                                            <th scope="col">Have Bite History</th>
                                            <th scope="col">Explanation</th>
                                            <th scope="col">Remove</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let dog of supplementalInfo.dogs; let id = index">
                                            <th scope="row" id="dogs{{id+1}}">{{id+1}}</th>
                                            <td>
                                                <select class="width-breed form-control" [(ngModel)]="dog.breedID"
                                                    [ngModelOptions]="{ updateOn: 'blur' }" name="ddlBreedTypes{{id}}"
                                                    #ddlBreedTypes="ngModel"
                                                    (ngModelChange)="checkForEmptyRowForDogs()">
                                                    <option selected value=""></option>
                                                    <option *ngFor="let item of supplementalInfo.lstBreedTypes"
                                                        [value]="item.lookupId">
                                                        {{item.lookupValue}}</option>
                                                </select>
                                            </td>
                                            <td>
                                                <select class="width-breed form-control"
                                                    [(ngModel)]="dog.mixedWithBreedID"
                                                    [ngModelOptions]="{ updateOn: 'blur' }"
                                                    name="ddlMixedBreedTypes{{id}}"
                                                    (ngModelChange)="checkForEmptyRowForDogs()">
                                                    <option selected value=""></option>
                                                    <option *ngFor="let item of supplementalInfo.lstBreedTypes"
                                                        [value]="item.lookupId">
                                                        {{item.lookupValue}}</option>
                                                </select>
                                            </td>
                                            <td class="text-sm-center">
                                                <input type="checkbox" [(ngModel)]="dog.haveBiteHistory"
                                                    class="ChKHaveBiteHistory" name="haveBiteHistory{{id}}"
                                                    [ngModelOptions]="{ updateOn: 'blur' }"
                                                    (ngModelChange)="checkForEmptyRowForDogs()" />
                                            </td>
                                            <td>
                                                <input type="text" class="width-90 form-control" maxlength="200"
                                                    [(ngModel)]="dog.explanation" name="explanation{{id}}"
                                                    [ngModelOptions]="{ updateOn: 'blur' }"
                                                    (ngModelChange)="checkForEmptyRowForDogs()" />
                                            </td>
                                            <td>
                                                <button type="button" color="danger" rounded="true" size="sm"
                                                    class="my-0 btn  remove-button"
                                                    (click)="remove(id, 'dogs');">Remove</button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                <div class="row">
                                    <div class="col-md-6">
                                        <label class="error-message text-nowrap" *ngIf="emptyDogsRowFlag">
                                            {{constantsObj.RequiredRow}}
                                        </label>
                                        <input type="hidden" [(ngModel)]="hdnDog" name="hdnDog" #ErrorDivDog>
                                    </div>
                                    <div class="col-md-6 text-right">
                                        <button type="button" class="button btn  add-button "
                                            (click)="add('dogs')">Add</button>
                                    </div>
                                </div>
                            </div>

                        </div>
                        <!-- End of Hide show table on click Do you own any dogs?  as YES -->

                        <div class="row pt-3">
                            <div class="col">
                                <div class="col">
                                    <div class="form-check form-check-inline pb-2 row w-100">
                                        <button type="button" [(ngModel)]="supplementalInfo.haveOtherPets"
                                            [value]="true"
                                            (click)="supplementalInfo.haveOtherPets?(UnCheck(template,'otherPets')):supplementalInfo.haveOtherPets=true;"
                                            #haveOtherPets="ngModel" name="radOtherPets" ngDefaultControl
                                            [ngClass]="{'active': supplementalInfo.haveOtherPets}"
                                            class="radio-btn btn btn-outline-dark">
                                            Other Pets/Animals
                                        </button>

                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- Start of hide show table on click Do you own any other kinds of pets or animals? YES -->
                        <div class="row pt-3" *ngIf="supplementalInfo.haveOtherPets">
                            <div class="col">
                                <table class="table table-bordered table-responsive">
                                    <thead class="table-header">
                                        <tr>
                                            <th scope="col" class="table-number-width">#</th>
                                            <th scope="col" class="table-descp-width">Description</th>
                                            <th scope="col" class="table-remove-width">Remove</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let other of supplementalInfo.otherPets; let id = index">
                                            <th scope="row" id="OtherPets{{id+1}}">{{id+1}}</th>
                                            <td>
                                                <input type="text" class="form-control pet-table-form-control"
                                                    [(ngModel)]="other.description"
                                                    [ngModelOptions]="{updateOn: 'blur'}" name="desc{{id}}"
                                                    #desc="ngModel" (ngModelChange)="checkForEmptyRowForOtherPets()" />
                                            </td>

                                            <td>
                                                <button type="button" color="danger" rounded="true" size="sm"
                                                    class="my-0 btn  remove-button"
                                                    (click)="remove(id, 'otherPets');">Remove</button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                <div class="row">
                                    <div class="col-md-6">
                                        <label class="error-message text-nowrap" *ngIf="emptyOtherPetsRowFlag">
                                            {{constantsObj.RequiredRow}}
                                        </label>
                                        <input type="hidden" [(ngModel)]="hdnOtherPets" name="hdnOtherPets"
                                            #ErrorOtherPets>
                                    </div>
                                    <div class="col-md-6 text-right ">
                                        <button type="button" class="button btn  add-button"
                                            (click)="add('otherPets')">Add</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- End of hide show table on click Do you own any other kinds of pets or animals? YES -->
                        <div class="row pt-3" *ngIf="!isRenters">
                            <div class="col">
                                <div class="col">
                                    <div class="form-check form-check-inline pb-2 row w-100">
                                        <button type="button" [(ngModel)]="supplementalInfo.haveRenovation"
                                            [value]="true"
                                            (click)="supplementalInfo.haveRenovation?(UnCheck(template,'renovations')):supplementalInfo.haveRenovation=true;"
                                            #haveRenovation="ngModel" name="radRenovation" ngDefaultControl
                                            [ngClass]="{'active': supplementalInfo.haveRenovation}"
                                            class="radio-btn btn btn-outline-dark">
                                            Select if you have completed any updates to heating, plumbing, roof or
                                            wiring
                                        </button>

                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- Start of hide show on click Have you completed any updates to heating, plumbing, roof o -->
                        <div class="row pt-3" *ngIf="supplementalInfo.haveRenovation">
                            <div class="col">
                                <table class="table table-bordered table-responsive">
                                    <thead class="table-header">
                                        <tr>
                                            <th scope="col">#</th>
                                            <th scope="col" class="renovationType-Width">Renovation Type</th>
                                            <th scope="col">Details</th>
                                            <th scope="col">Extent</th>
                                            <th scope="col">Year Completed</th>
                                            <th scope="col">Remove</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let renovation of supplementalInfo.renovations; let id = index">
                                            <th scope="row" id="rennovation{{id+1}}">{{id+1}}</th>
                                            <td>
                                                <select class="width-breed form-control" [(ngModel)]="renovation.type"
                                                    [ngModelOptions]="{ updateOn: 'blur' }"
                                                    name="ddlRenovationType{{id}}" #ddlRenovationType="ngModel"
                                                    (ngModelChange)="checkForEmptyRowForRennovation()">
                                                    <option selected value=""></option>
                                                    <option *ngFor="let item of supplementalInfo.lstRenovationTypes"
                                                        [value]="item.lookupId">
                                                        {{item.lookupValue}}</option>
                                                </select>
                                            </td>
                                            <td class="yearCompleted">
                                                <input type="text" class="width-breed form-control" maxlength="50"
                                                    [(ngModel)]="renovation.details"
                                                    [ngModelOptions]="{ updateOn: 'blur' }"
                                                    (ngModelChange)="checkForEmptyRowForRennovation()"
                                                    name="details{{id}}" #details="ngModel" />
                                            </td>
                                            <td>
                                                <select class="width-breed form-control"
                                                    [(ngModel)]="renovation.extentType"
                                                    [ngModelOptions]="{ updateOn: 'blur' }" name="ddlextentType{{id}}"
                                                    (ngModelChange)="checkForEmptyRowForRennovation()"
                                                    #ddlextentType="ngModel">
                                                    <option selected value=""></option>
                                                    <option
                                                        *ngFor="let item of supplementalInfo.lstRenovationExtentTypes"
                                                        [value]="item.lookupId">
                                                        {{item.lookupValue}}</option>
                                                </select>
                                            </td>
                                            <td>
                                                <input type="text" maxlength="4" OnlyNumber
                                                    class="width-year form-control"
                                                    [(ngModel)]="renovation.yearCompleted"
                                                    [ngModelOptions]="{ updateOn: 'blur' }"
                                                    (ngModelChange)="checkForEmptyRowForRennovation()"
                                                    #yearCompleted="ngModel" name="yearCompleted{{id}}" />
                                            </td>
                                            <td>
                                                <button type="button" color="danger" rounded="true" size="sm"
                                                    class="my-0 btn  remove-button"
                                                    (click)="remove(id, 'renovations');">Remove</button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                <div class="row">
                                    <div class="col-md-6">
                                        <label class="error-message text-nowrap" *ngIf="emptyRennovationFlag">
                                            {{constantsObj.RequiredRow}}
                                        </label>
                                        <input type="hidden" [(ngModel)]="hdnRenovations" name="hdnRenovations"
                                            #ErrorRenovations>
                                    </div>
                                    <div class="col-md-6 text-right">
                                        <button type="button" class="button btn  add-button"
                                            (click)="add('renovations')">Add</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- End of hide show on click Have you completed any updates to heating, plumbing, roof o -->

                        <div class="row pt-3" *ngIf="!isRenters">
                            <div class="col">
                                <div class="col">
                                    <div class="form-check form-check-inline pb-2 row w-100">
                                        <button type="button" [(ngModel)]="supplementalInfo.haveClaims" [value]="true"
                                            (click)="supplementalInfo.haveClaims?(UnCheck(template,'loss')):supplementalInfo.haveClaims=true;"
                                            #haveClaims="ngModel" name="radhaveClaims" ngDefaultControl
                                            [ngClass]="{'active': supplementalInfo.haveClaims}"
                                            class="radio-btn btn btn-outline-dark">
                                            Select if you have filed any claims, including weather-related, in the last
                                            5 years
                                        </button>

                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- Start of hide show on click Have you filed any claims, including weather-related, in the last 5 -->
                        <div class="row pt-3" *ngIf="supplementalInfo.haveClaims">
                            <div class="col">
                                <table class="table table-bordered table-responsive">
                                    <thead class="table-header">
                                        <tr>
                                            <th scope="col">#</th>
                                            <th scope="col">Loss Date</th>
                                            <th scope="col">Cause Of Loss</th>
                                            <th scope="col">Loss Amount</th>
                                            <th scope="col">Note</th>
                                            <th scope="col">Remove</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let loss of supplementalInfo.lossHistories; let id = index">
                                            <th scope="row">{{id+1}}</th>
                                            <td>
                                                <input type="text" name="txtClaimDate{{id}}" class="form-control"
                                                    [(ngModel)]="loss.date" #dp="bsDatepicker" [maxDate]="maxDate"
                                                    #claimDate="ngModel" bsDatepicker [outsideClick]="false"
                                                    placeholder="MM/DD/YYYY"
                                                    [bsConfig]="{ showWeekNumbers:false, dateInputFormat: 'MM/DD/YYYY' }"
                                                    dateValidator (keydown.Tab)="hideDatePicker(dp)">
                                                <label
                                                    *ngIf="(claimDate.hasError('dateValidator') && claimDate.touched)"
                                                    class="error-message text-nowrap">{{constantsObj.invalidFormatErrorMessage}}</label>
                                                <label
                                                    *ngIf="(claimDate.hasError('maxDateValidator') && claimDate.touched)"
                                                    class="error-message text-nowrap">{{constantsObj.invalidFutureDate}}</label>
                                            </td>
                                            <td class="yearCompleted">
                                                <select class="form-control" [(ngModel)]="loss.cause"
                                                    [ngModelOptions]="{ updateOn: 'blur' }" name="ddlLossTypes{{id}}"
                                                    #ddlLossTypes="ngModel"
                                                    (ngModelChange)="checkForEmptyRowForClaims()">
                                                    <option selected value=""></option>
                                                    <option *ngFor="let item of supplementalInfo.lstLossTypes"
                                                        [value]="item.lookupId">
                                                        {{item.lookupValue}}</option>
                                                </select>
                                            </td>
                                            <td>
                                                <input type="text" class="form-control" [ngModel]="loss.amountPaid"
                                                    appTwoDigitDecimaNumber [ngModelOptions]="{ updateOn: 'blur' }"
                                                    name="amountPaid{{id}}" #amoutrPaid="ngModel"
                                                    (ngModelChange)="loss.amountPaid=$event; checkForEmptyRowForClaims()" />
                                            <td>
                                                <input type="text" class="form-control" maxlength="250"
                                                    [(ngModel)]="loss.note" #note="ngModel"
                                                    (ngModelChange)="checkForEmptyRowForClaims()" name="note{{id}}"
                                                    [ngModelOptions]="{ updateOn: 'blur' }" />
                                            </td>
                                            <td>
                                                <button type="button" color="danger" rounded="true" size="sm"
                                                    class="my-0 btn  remove-button"
                                                    (click)="remove(id, 'loss');">Remove</button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                <div class="row">
                                    <div class="col-md-6">
                                        <label class="error-message text-nowrap" *ngIf="emptyClaimsFlag">

                                            {{constantsObj.RequiredRow}}
                                        </label>
                                        <input type="hidden" [(ngModel)]="hdnLoss" name="hdnLoss" #ErrorLoss>
                                    </div>
                                    <div class="col-md-6 text-right">
                                        <button type="button" class="button btn  add-button"
                                            (click)="add('loss')">Add</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- End of hide show on click Have you filed any claims, including weather-related, in the last 5 -->
                    </div>
                    <div class="container pt-4">
                        <div class="row">
                            <p class="req-msg-note">*These fields are required</p>
                        </div>
                    </div>
                    <!-- Button -->
                    <div class="row">
                        <div class="col">
                            <button type="button" tabindex="-1"
                                class="btn angled-button-sm button-width-110 button-align-mob-previous previous-left"
                                (click)="commonService.NavigateToPage('real-time-quote/home-info')">
                                <span>Previous</span>
                            </button>
                        </div>
                        <div class="col">
                            <button type="submit" class="btn angled-button-sm button-align-mob-next btn-next-120">
                                <span>Next</span>
                            </button>
                        </div>
                    </div>
                    <div class="row pt-3">
                        <button type="button" class="btn angled-button-sm button-width-190 button-align-mob-center"
                            (click)="this.popUp.openModal()">
                            <span>Please contact me</span>
                        </button>
                    </div>
                    <!-- // Button -->
                </div>
            </div>
        </div>
    </section>
    <div class="container">
        <div class="row justify-content-center">
            <app-model-popup (savePageDetails)="savePageDetails()"></app-model-popup>
            <div class="row">
                <div class="col">
                    <ng-template #template>
                        <div class="modal-body text-center" data-backdrop="static" data-keyboard="false">
                            <p>This will delete all the data from the grid. Do you want to continue?</p>
                            <button type="button" class="btn btn-RTQ m-2" (click)="confirm()">Okay</button>
                            <button type="button" class="btn btn-RTQ " (click)="decline()">Cancel</button>
                        </div>
                    </ng-template>
                </div>
            </div>
        </div>
    </div>
</form>
<!-- //END OF FORM -->